import { lmsClient } from "api";

const lmsLoanPaymentService = {};

/**
 * 1. Listing Loans
 * support pagination & filter
 */
lmsLoanPaymentService.getLoans = function (data) {
  const params = new URLSearchParams();

  // Pagination
  if (data?.pageSize) params.append("pageSize", data.pageSize);
  if (data?.pageIndex) params.append("page", data.pageIndex);

  // Filter optional
  if (data?.branchId) params.append("branchId", data.branchId);
  if (data?.name) params.append("name", data.name);
  if (data?.loanNo) params.append("loanNo", data.loanNo);
  if (data?.nomorPolisi) params.append("nomorPolisi", data.nomorPolisi);

  return lmsClient({
    url: `/lms/loan/paging?${params.toString()}`,
    method: "get",
  });
};

/**
 * 2. Detail Loan by ApplicationId
 */
lmsLoanPaymentService.getLoanDetail = function (data) {
  return lmsClient({
    url: `/lms/loan/${data.loanNo}`,
    method: "get",
  });
};

/**
 * 3. Instalment Schedule by ApplicationId
 */
lmsLoanPaymentService.getInstallmentSchedule = function (data) {
  const params = new URLSearchParams();

  if (data?.pageSize) params.append("pageSize", data.pageSize);
  if (data?.pageIndex) params.append("pageIndex", data.pageIndex);
  if (data?.tanggalValuta) params.append("tanggalValuta", new Date(data.tanggalValuta).toISOString());

  return lmsClient({
    url: `/lms/loan/${data.applicationId}/installments?${params.toString()}`,
    method: "get",
  });
};

/**
 * 4. Proses Payment
 */
lmsLoanPaymentService.createPayment = function (payload) {
  return lmsClient({
    url: `/lms/payment`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

/**
 * 5. Payment History by ApplicationId
 */
lmsLoanPaymentService.getPaymentHistory = function (data) {
  return lmsClient({
    url: `/lms/paymenthistory/${data.applicationId}`,
    method: "get",
  });
};

// angsuran jatuh tempo
lmsLoanPaymentService.getInstallmentDue = function(data) {
  return lmsClient({
    url: `/lms/loan/${data.loanNo}/installmentdue?tanggalValuta=${data.tanggalValuta}`,
    method: "get",
  })
}

lmsLoanPaymentService.getPaymentPriorities = function(data) {
  return lmsClient({
    url: `/lms/paymentpriority/by-dpd/${data.dpd}`,
    method: "get"
  })
}

export default lmsLoanPaymentService;